export default {
  "HitPaw Online Audio Joiner": "HitPaw Online Penggabung Audio",
  "Merge Audio": "Gabungkan Audio",
  "Merge multiple audio tracks into one.": "Gabungkan beberapa trek audio menjadi satu.",
  "Merge New": "Gabung Baru",
  "Merge failed": "Penggabungan gagal",
  "Fade in": "Fade in",
  "Fade out": "Fade out",
  "Add tracks": "Tambahkan trek",
  "Format": "Format",
};
